import { createUninitializedContext } from '@crew/utils/context'
import {} from '@reduxjs/toolkit/query'
import { Dispatch, SetStateAction } from 'react'

/** Context用の型 */
type ProjectDetailManagementPanelContextType = {
  projectSubject: string
  setProjectSubject: Dispatch<SetStateAction<string>>
}

/** Context */
const {
  context: projectDetailManagementPanelContext,
  useInitializedContext: useProjectDetailManagementPanelContext,
} = createUninitializedContext<ProjectDetailManagementPanelContextType>()

export { useProjectDetailManagementPanelContext }

export const useProjectDetailManagementPanel = () => {
  return {
    projectDetailManagementPanelContext,
  }
}
